import { lazy, Suspense } from 'react';

import { EBOOK_PDF } from 'global/constants';
import { ViewProps } from './ebook.constants';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';
import { useDocumentViewErrorListener } from '../document/document-view.hooks';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { getSmallestImage } from '../shared/logic/get-smallest-image';

const DocumentPreviewImages = lazy(
  () => import('../document/document-preview')
);
const DocumentPreviewPdf = lazy(
  () => import('../document/document-preview-pdf')
);

const EbookView = (
  props: ViewProps & {
    isStudent?: boolean;
    onStimulusOpen?: () => void;
  }
) => {
  const { hasError } = useDocumentViewErrorListener();
  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: getSmallestImage(
      props.stimulusResourceProperties?.xlCoverImageUrls || []
    ),
  });

  return props.stimulusResourceProperties?.documentKey ? (
    <ComponentAspectRatio dimensions={props.properties.dimensionData}>
      <Suspense fallback={<div />}>
        <ComponentAbsoluteWrapper $centred={false} ref={setContainerElement}>
          {hasError ? (
            <DocumentPreviewImages
              documentKey={props.stimulusResourceProperties.documentKey}
              name={props.stimulusResourceProperties.resourceName}
              description={props.stimulusResourceProperties.description}
              badgeName={getStimulusLabel(EBOOK_PDF)}
              type={EBOOK_PDF}
              link={props.stimulusResourceProperties.link}
              showDetails={false} // todo: will be redesigned
              isStudent={props.isStudent}
              onExpand={props.onStimulusOpen}
            />
          ) : (
            <DocumentPreviewPdf
              name={props.stimulusResourceProperties.resourceName}
              description={props.stimulusResourceProperties.description}
              badgeName={getStimulusLabel(EBOOK_PDF)}
              type={EBOOK_PDF}
              link={props.stimulusResourceProperties.link}
              showDetails={false} // todo: will be redesigned
              onExpand={props.onStimulusOpen}
              isStudent={props.isStudent}
              coverImage={
                props.stimulusResourceProperties.xlCoverImageUrls?.length
                  ? getClosestImageUrl({
                      imageUrls:
                        props.stimulusResourceProperties.xlCoverImageUrls,
                      containerSize: imageDimensions?.width
                        ? Math.max(
                            imageDimensions.width,
                            imageDimensions.height
                          )
                        : window.innerWidth,
                      quality: ImageDisplayQuality.High,
                    })
                  : undefined
              }
              thumbnail={
                props.stimulusResourceProperties.coverImage?.original ||
                undefined
              }
            />
          )}
        </ComponentAbsoluteWrapper>
      </Suspense>
    </ComponentAspectRatio>
  ) : null;
};

export default EbookView;
